import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';
import { YesNoComponent } from '../yes-no/yes-no.component';
@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
constructor(private readonly updates: SwUpdate,
    public dialog: MatDialog) {
      // updates.versionUpdates.subscribe(evt => {
      //   switch (evt.type) {
      //     case 'VERSION_DETECTED':
      //       console.log(`Downloading new app version: ${evt.version.hash}`);
      //       break;
      //     case 'VERSION_READY':
      //       console.log(`Current app version: ${evt.currentVersion.hash}`);
      //       console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
      //       this.showAppUpdateAlert();
      //       break;
      //     case 'VERSION_INSTALLATION_FAILED':
      //       console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
      //       break;
      //   }
      // });
this.checkForUpdate();
      
    }
    async checkForUpdate() {
 var isAppUpdateAvailable = await this.updates.checkForUpdate();

if(isAppUpdateAvailable){
  this.showAppUpdateAlert();
}else{
  console.log("No updates available");
}
}

showAppUpdateAlert() {
  const header = 'App Update available';
  const message = 'Choose Yes to update';
  const action = this.doAppUpdate;
  const caller = this;
  // Use MatDialog or ionicframework's AlertController or similar
  this.presentAlert(header, message, action, caller);
}

presentAlert(header,message,action,caller){

  let dialogRef = this.dialog.open(YesNoComponent, {
    width: '250px',
    data: { title: header, message: message }
  });

  dialogRef.afterClosed().subscribe(result => {
     if(result.status){
         action
     }
  });
}

doAppUpdate() {
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}


